<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="lang-box" :class="{ 'white-bg': isWhite }">
        <!-- <span class="lang" :class="{ 'active': $i18n.locale === 'zh' }" @click="changeLang('zh')">中文</span> / -->
        <span class="lang" :class="{ 'active': $i18n.locale === 'en' }" @click="changeLang('en')">EN</span> /
        <span class="lang" :class="{ 'active': $i18n.locale === 'pt' }" @click="changeLang('pt')">Português</span>
    </div>
</template>
<script>
export default {
    computed: {
        isWhite() {
            return (
                (this.$route.path === '/about' || this.$route.path === '/awards' || this.$route.path === '/blog' || this.$route.path === '/duty') &&
                window.innerWidth > 769
            )
        }
    },
    methods: {
        changeLang(lang) {
            this.$i18n.locale = lang
            localStorage.setItem('lang', lang)
        }
    }
}
</script>
<style lang="less" scoped>
.lang-box {
    color: var(--index-sub-content-color);
    font-size: 16px;
    line-height: 24px;
}
.lang {
    border-radius: 3px;
    cursor: pointer;
    display: inline-block;
    font-size: 17px;
    padding: 0 2px;
    &.active {
        border-bottom: 1px solid #fff;
        color: #fff;
        font-weight: 900;
    }
}
.white-bg {
    color: #333;
    .lang {
        &.active {
            border-bottom: 1px solid #000;
            color: #000;
        }
    }
}
</style>
